import BvSpinner from '../../components/bv-spinner';
import Onboarding from '../../components/onboarding';
import RouteTemplate from 'ember-route-template';

export default RouteTemplate<{ Args: { model: unknown; controller: unknown } }>(
  <template>
    <Onboarding>
      <BvSpinner />
    </Onboarding>
  </template>
);
